import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IOptionsCardForm } from "libraries/module/formbuilder/forms/card-form/card-form.component";
import { SearchFormHelperService } from "app_sasha/shared/services/search-form-helper/search-form-helper.service";
import { FormControl, FormGroup } from "@angular/forms";
import {
    EProcessReportSearchParts
} from "app_sasha/pages/process-report/components/process-report-search-form/e-process-report-search-parts";
import { IFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";
import {
    IDateRangeOptionConfig,
    OptionConfigTypes
} from "app_sasha/shared/components/date-field-set/date-field-set.component";
import { IMultiselectOptions } from "libraries/module/formbuilder/fields/multiselect/multiselect.model";
import { Required } from "libraries/module/formbuilder/forms/utils/validators/required.validator";
import { ISummary } from "libraries/component/search-summary/ISummary";
import { QueryParamsMappingService } from "app_sasha/pages/process-report/query-params-mapping.service";
import { Wording } from "app_sasha/pages/process-report/components/process-report-search-form/wording";
import { Yii } from "libraries/interfaces/Yii";

export interface IProcessReportSearchFormConfig {
    [EProcessReportSearchParts.hostCodeArray]: IFieldSpecs;
    [EProcessReportSearchParts.statusArray]: IFieldSpecs;
    [EProcessReportSearchParts.whenType]: IFieldSpecs;
    [EProcessReportSearchParts.whenCreated]?: IDateRangeOptionConfig;
    [EProcessReportSearchParts.whenCancelled]?: IDateRangeOptionConfig;
    hostCodeOptions: IMultiselectOptions[];
    statusOptions: IMultiselectOptions[];
    whenTypeOptions: IMultiselectOptions[];
}

export interface IProcessReportSearchFormValue {
    [EProcessReportSearchParts.hostCodeArray]?: string[];
    [EProcessReportSearchParts.statusArray]?: string[];
    [EProcessReportSearchParts.whenCreated]?: {
        [EProcessReportSearchParts.whenCreatedMin]: Date;
        [EProcessReportSearchParts.whenCreatedMax]: Date;
    };
    [EProcessReportSearchParts.whenCancelled]?: {
        [EProcessReportSearchParts.whenCancelledMin]: Date;
        [EProcessReportSearchParts.whenCancelledMax]: Date;
    };
}

@Component({
    selector: 'process-report-search-form',
    template: `
        <card-form *ngIf="processReportSearchFormConfig"
                   [hidden]="!isContentVisible"
                   [options]="cardOptions"
                   [disabled]="!formGroup.valid"
                   (onSubmit)="launchSearch()">
            <div class="card-header-content">
                <h1>{{wording.title }}</h1>
                <div class="btn-right">
                    <btn type="actionHeaderLink"
                         [value]="wording.reset"
                         (onClick)="reset()"></btn>
                    <btn type="actionDo"
                         [value]="wording.modifySearch"
                         (onClick)="toggleContent(!isContentVisible)"></btn>
                </div>
            </div>
            <div class="card-body-content">

                <ng-container>
                    <div class="col-to-row-s-tb fix-top">

                        <div class="flex-1 sep-right sep-top">
                            <div>
                                <multiselect [apiOptions]="processReportSearchFormConfig.hostCodeOptions"
                                             [fieldConfig]="processReportSearchFormConfig[fields.hostCodeArray]"></multiselect>
                            </div>
                            <div class=" sep-top">
                                <multiselect [options]="processReportSearchFormConfig.statusOptions"
                                             [showHeader]="false"
                                             [fieldConfig]="processReportSearchFormConfig[fields.statusArray]"></multiselect>

                            </div>
                        </div>
                        <div class="flex-1 sep-top">
                            <!--                            <div>-->
                            <!--                                <multiselect [apiOptions]="processReportSearchFormConfig.whenTypeOptions"-->
                            <!--                                             [maxSelection]="1"-->
                            <!--                                             [showHeader]="false"-->
                            <!--                                             [mustEmitChangeOnClick]="true"-->
                            <!--                                             [fieldConfig]="processReportSearchFormConfig[fields.whenType]"></multiselect>-->

                            <!--                            </div>-->
                            <div>
                                <date-range-field
                                        [fieldConfig]="processReportSearchFormConfig[fields.whenCreated].fieldConfig"
                                        [formGroup]="whenCreatedFormGroup"></date-range-field>

                            </div>
                            <!--                            <div *ngIf="!isCreatedAction">-->
                            <!--                                <date-range-field-->
                            <!--                                        [fieldConfig]="processReportSearchFormConfig[fields.whenCancelled].fieldConfig"-->
                            <!--                                        [formGroup]="formGroup.get(processReportSearchFormConfig[fields.whenCancelled].formControl)"></date-range-field>-->

                            <!--                            </div>-->

                        </div>
                    </div>

                </ng-container>
            </div>
        </card-form>
        <ng-container *ngIf="!isContentVisible">
            <search-summary [fields]="summary"
                            [title]="wording.titleSummary"
                            (onRemove)="removeElement($event)"
                            (onModifySearch)="toggleContent(!isContentVisible)"></search-summary>
        </ng-container>
    `,
    styles: [`
        .card-body-content {
            padding: 0 .75rem .75rem .75rem;
        }

        .card-body-content notification {
            margin-bottom: .75rem;
        }

        .btn-right {
            margin-right: .75rem;
        }

        .fix-top {
            align-items: baseline;
        }
    `]
})

export class ProcessReportSearchFormComponent implements OnInit, OnChanges {

    @Input()
    public isContentVisible: boolean;

    @Input()
    public searchRequest: IProcessReportSearchFormValue;

    @Output()
    public readonly isContentVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output()
    public readonly onReset: EventEmitter<void> = new EventEmitter<void>();

    @Output()
    public readonly onSearch: EventEmitter<IProcessReportSearchFormValue> = new EventEmitter<IProcessReportSearchFormValue>();

    public processReportSearchFormConfig: IProcessReportSearchFormConfig;

    public fields: typeof EProcessReportSearchParts = EProcessReportSearchParts;

    public wording: Wording = new Wording();

    public disabled: boolean = false;

    public isCreatedAction: boolean;

    public cardOptions: IOptionsCardForm = {
        formGroup: null,
        labels: {
            error: this.wording.error,
            submit: this.wording.search,
        },
    };

    public formGroup: FormGroup;
    public whenCreatedFormGroup: FormGroup;

    public summary: ISummary[];

    constructor(
        private readonly searchFormHelperService: SearchFormHelperService,
        private readonly queryParamsMappingService: QueryParamsMappingService,
    ) {
    }

    public ngOnInit(): void {
        this.initSummary();
        this.initFormGroup();
        this.initConfig();
        this.patchForm();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (this.formGroup && changes.searchRequest?.currentValue) {
            this.initSummary();
            this.patchForm();
        }
    }

    public initSummary(): void {
        this.summary = this.queryParamsMappingService.mapFormtoSummary(this.searchRequest);
    }

    public toggleContent(state: boolean): void {
        this.isContentVisible = state;
        this.isContentVisibleChange.emit(this.isContentVisible);
    }

    public reset(): void {
        this.formGroup.reset({});
        this.onReset.emit();
    }

    public launchSearch(): void {
        this.onSearch.emit(this.formGroup.value);
    }

    public removeElement(event: ISummary[]): void {
        this.formGroup.get(event[0].field as string).reset();
        this.launchSearch();
    }

    private initFormGroup(): void {
        this.whenCreatedFormGroup = new FormGroup({
            [EProcessReportSearchParts.whenCreatedMin]: new FormControl(),
            [EProcessReportSearchParts.whenCreatedMax]: new FormControl(),
        });
        this.formGroup = new FormGroup(
            {
                [EProcessReportSearchParts.hostCodeArray]: new FormControl([]),
                [EProcessReportSearchParts.statusArray]: new FormControl([]),
                [EProcessReportSearchParts.statusArray]: new FormControl([]),
                [EProcessReportSearchParts.whenCreated]: this.whenCreatedFormGroup,
            }
        );
        this.cardOptions.formGroup = this.formGroup;
    }

    private initConfig(): void {
        this.searchFormHelperService.getHosts()
            .subscribe({
                next: (hostCodeOptions: IMultiselectOptions[]): void => {
                    this.processReportSearchFormConfig = {
                        hostCodeOptions,
                        statusOptions: [
                            {
                                value: 'OK',
                                label: 'OK',
                            },
                            {
                                value: 'Danger',
                                label: 'Danger',
                            },
                        ],
                        whenTypeOptions: [
                            {
                                value: EProcessReportSearchParts.whenCreated,
                                label: Yii.t('wui-shared-js', 'Création'),
                            },
                            {
                                value: EProcessReportSearchParts.whenCancelled,
                                label: Yii.t('wui-shared-js', 'Annulation'),
                            },
                        ],
                        [EProcessReportSearchParts.hostCodeArray]: this.searchFormHelperService
                            .createSimpleConfig(
                                EProcessReportSearchParts.hostCodeArray,
                                this.formGroup,
                                this.wording.systems,
                                this.wording.systemDescription
                            ),
                        [EProcessReportSearchParts.statusArray]: this.searchFormHelperService
                            .createSimpleConfig(
                                EProcessReportSearchParts.statusArray,
                                this.formGroup,
                                this.wording.status,
                                this.wording.statusDescription
                            ),
                        [EProcessReportSearchParts.whenType]: this.searchFormHelperService
                            .createSimpleConfig(
                                EProcessReportSearchParts.whenType,
                                this.formGroup,
                                this.wording.whenType,
                                this.wording.whenTypeDescription
                            ),
                        [EProcessReportSearchParts.whenCreated]: {
                            label: this.wording[EProcessReportSearchParts.whenCreated],
                            type: OptionConfigTypes.DateRange,
                            fieldConfig: {
                                min: {
                                    formGroup: this.whenCreatedFormGroup as FormGroup,
                                    formControlName: EProcessReportSearchParts.whenCreatedMin,
                                    maxDate: new Date(),
                                    label: this.wording[EProcessReportSearchParts.whenCreatedMin],
                                    description: this.wording[EProcessReportSearchParts.whenCreatedMinDescription],
                                    withAsteriskIfRequired: true,
                                    validators: [new Required()],
                                },
                                max: {
                                    formGroup: this.whenCreatedFormGroup as FormGroup,
                                    formControlName: EProcessReportSearchParts.whenCreatedMax,
                                    maxDate: new Date(),
                                    label: this.wording[EProcessReportSearchParts.whenCreatedMax],
                                    description: this.wording[EProcessReportSearchParts.whenCreatedMaxDescription],
                                    withAsteriskIfRequired: true,
                                    validators: [new Required()],
                                },
                            },
                            formControl: EProcessReportSearchParts.whenCreated,
                        },
                    };

                }

            });
    }

    private patchForm(): void {

        if (this.searchRequest) {
            this.formGroup.patchValue(this.searchRequest);
        } else {
            const today: Date = new Date();
            const yesterday: Date = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);

            this.whenCreatedFormGroup.setValue({
                [EProcessReportSearchParts.whenCreatedMin]: yesterday,
                [EProcessReportSearchParts.whenCreatedMax]: today,
            });
        }
    }
}
